import React, {useState,memo,useEffect} from 'react'
import IxModal from '../../composite/ix-modal'
import RlTimepicker from '../../composite/rl-time-picker'
import moment from 'moment'
import { connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {Typography} from '@material-ui/core';
import useStyles  from '../pickup-time/styles';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import {useDispatch} from "react-redux"
import {selectPickupTime,reFetchPickupTimeRange,setSuggestedPickupTime} from "../pickup-time/pickupTimeSlice"

const PickupTimeModal = ({
    history,
    pickupTimeStore,
    fetchPickupTimeRange,
    setSelectedPickupTime,
    appState,
    openModal,
    setOpenModal,
    loading
}) => {
  
    const[selectTime, setSelectTime]=useState("")
    const [pickupTime, setPickupTime] = useState([]);
    const { t } = useTranslation();
    const classes = useStyles();
   const dispatch = useDispatch()

    const handleContinueBtnAction = () => {
        setSelectedPickupTime(selectTime)
        dispatch(setSuggestedPickupTime(true))
        handleClose()

      };
    
    const handleClose = ()=>{
        setOpenModal(false)
    }  
    
    const checkAgainstCurrentTime = (timeList)=>{
        let currentTime = moment()
         let timelist = timeList.filter((value,index)=>(
          value.isOpen&&currentTime.valueOf() < moment(value.time24, 'hh:mm').valueOf()
         ))
        setPickupTime(timelist)
    }
     
    const callPickupTimeRangeApi =async(data)=>{
         await fetchPickupTimeRange(data)
    }
    useEffect(()=>{
        if(appState &&appState.session){
          callPickupTimeRangeApi({
            branchId:appState.session.data.id,
            companyId:appState.session.data.companyId
          })
        }
        
    },[])
    useEffect(()=>{
        if(
          pickupTimeStore && 
          pickupTimeStore.pickupTimeRange && 
          pickupTimeStore.pickupTimeRange.data && 
          pickupTimeStore.pickupTimeRange.data.length !==0 
          ){
            checkAgainstCurrentTime(pickupTimeStore.pickupTimeRange.data)
          }
    },[pickupTimeStore.pickupTimeRange.data]) 



    return (
        <IxModal 
         open={openModal}
         maxWidth="450px"

         modaltitle={t('TimeSlotErrMsg')}
        >
         {openModal &&
           pickupTime && 
           pickupTime.length !==0 ?
          <div>
            <RlTimepicker 
                timeList={pickupTime} 
                setSelectTime={setSelectTime}
                margin="0rem"
            />
            <DialogActions>
                <Box width="40%">
                {/* <Field name="isActive" component={IxSwitch} label={t('common.active')}></Field> */}
                </Box>
                <Button variant="contained" onClick={handleClose}>
                {t('Cancel')}
                </Button>
                <Button type="submit"  onClick={handleContinueBtnAction} variant="contained" disabled={loading} style={{backgroundColor:"#ffe100"}}>
                {t('Submit')}
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </DialogActions>
          </div> 
          :
          <div>

            <Typography className={classes.message}>
             {t('noSlotAvailable')}
            </Typography>
            <DialogActions>
                <Box width="40%">
                {/* <Field name="isActive" component={IxSwitch} label={t('common.active')}></Field> */}
                </Box>
                <Button variant="contained" onClick={handleClose}>
                {t('Cancel')}
                </Button>
                <Button type="submit" onClick={handleContinueBtnAction} variant="contained" disabled={loading} style={{backgroundColor:"#ffe100"}}>
                {t('Submit')}
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </DialogActions>
          </div>
        }
        </IxModal>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
      fetchPickupTimeRange: () => {
        dispatch(reFetchPickupTimeRange());
      },
      setSelectedPickupTime: (pickupTime) => {
        dispatch(selectPickupTime(pickupTime));
      },
      
  
  };
  }
  
  const mapStateToProps = ({pickupTime,appState }) => {
    return {
      pickupTimeStore:pickupTime,
      appState
    };
  };

export default connect(
    mapStateToProps,
    mapDispatchToProps,
  ) (memo(PickupTimeModal))
